<template>
  <div :class="className">
    <LmCheckbox
      variant="switch"
      v-model="showPermissionsOptions"
      labelSingle="Gestionar permisos de usuario"
    />
    <template v-if="showPermissionsOptions">
      <LmSuperPowerSelectV2
        class="col-12 mb-0 px-0"
        v-model="form.allowAccess"
        :multiple='true'
        :options="privilegesSuperPowerOptions"
        label="Permitir acceso"
        placeholder="Privilegios que tendrán acceso"
        :pageSize="20"
      />
      <b-button variant="link" class="my-2" @click="setMyPrivileges('access')">Setear mis privilegios</b-button>
      <b-button variant="link" class="my-2" @click="setAllPrivileges('access')">Setear todos los privilegios</b-button>
      <LmSuperPowerSelectV2
        class="col-12 mb-0 px-0"
        v-model="form.allowCreate"
        :multiple='true'
        :options="privilegesSuperPowerOptions"
        label="Permitir crear"
        placeholder="Privilegios que podran crear"
        :pageSize="20"
      />
      <b-button variant="link" class="my-2" @click="setMyPrivileges('create')">Setear mis privilegios</b-button>
      <b-button variant="link" class="my-2" @click="setAllPrivileges('create')">Setear todos los privilegios</b-button>
      <LmSuperPowerSelectV2
        class="col-12 mb-0 px-0"
        v-model="form.allowUpdate"
        :multiple='true'
        :options="privilegesSuperPowerOptions"
        label="Permitir actualizar"
        placeholder="Privilegios que podran actualizar"
        :pageSize="20"
      />
      <b-button variant="link" class="my-2" @click="setMyPrivileges('update')">Setear mis privilegios</b-button>
      <b-button variant="link" class="my-2" @click="setAllPrivileges('update')">Setear todos los privilegios</b-button>
    </template>
  </div>
</template>

<script>
import LmCheckbox from '@/components/form/elements/LmCheckbox'
import LmSuperPowerSelectV2 from '@/components/form/elements/LmSuperPowerSelectV2'
import { getCurrentUserPrivileges } from '@/helpers/userPermissions'
import _ from 'lodash'
import commonsApi from '@/api/commons'

export default {
  props: {
    form: {
      type: Object,
      default: () => ({})
    },
    className: {
      type: String,
      default: 'col-12'
    }
  },
  data () {
    return {
      showPermissionsOptions: false,
      privilegesSuperPowerOptions: [],
      isOnEditMode: !!this.$route.params?.id
    }
  },
  components: {
    LmCheckbox,
    LmSuperPowerSelectV2
  },
  methods: {
    setMyPrivileges (payload) {
      const myPrivileges = getCurrentUserPrivileges()
      switch (payload) {
        case 'access':
          this.form.allowAccess = myPrivileges
          break
        case 'create':
          this.form.allowCreate = myPrivileges
          break
        case 'update':
          this.form.allowUpdate = myPrivileges
          break
        default:
          break
      }
    },
    setAllPrivileges (payload) {
      const allPrivileges = _.cloneDeep(this.privilegesSuperPowerOptions)
      switch (payload) {
        case 'access':
          this.form.allowAccess = allPrivileges
          break
        case 'create':
          this.form.allowCreate = allPrivileges
          break
        case 'update':
          this.form.allowUpdate = allPrivileges
          break
        default:
          break
      }
    }
  },
  created () {
    this.unWatchFormPermissions = this.$watch('form', (newVal) => {
      if (newVal && typeof newVal === 'object' && this.isOnEditMode) {
        if (
          newVal?.allowAccess?.length ||
          newVal?.allowCreate?.length ||
          newVal?.allowUpdate?.length
        ) {
          this.showPermissionsOptions = true
        }
        this.unWatchFormPermissions()
      }
    }, {
      deep: true
    })
  },
  async mounted () {
    const path = process?.env?.VUE_APP_USER_PRIVILEGES_PATH || '/codificatorbuilder/codificators/60ef50e476b81943ec4d99da'
    const { data } = await commonsApi.axiosGetWrapper(path)
    this.privilegesSuperPowerOptions = data.items
    if (!this.isOnEditMode) {
      const myPrivileges = getCurrentUserPrivileges()
      this.form.allowAccess = myPrivileges
    }
  }
}
</script>
